import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';

import { DebugPanelComponent } from '@finder/shared/components/debug-panel/debug-panel.component';
import { DebugCheckService } from '@finder/shared/services/debug-check/debug-check.service';
import { LazyLoaderService } from '../lazy-loader/lazy-loader-service';
import { from } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class DebugPanelService {
    debugComponentRef: ComponentRef<DebugPanelComponent>;

    constructor(
        private logger: LoggerService,
        private debugCheckService: DebugCheckService,
        private lazyLoader: LazyLoaderService
    ) {}

    createDebugPanel(viewContainerRef: ViewContainerRef, svcResponse: any) {
        try {
            const debugPanelEnabled = this.debugCheckService.isDebugEnabled();
            const debugModalEnabled = this.debugCheckService.isDebugModalEnabled();

            if (!debugPanelEnabled) {
                return;
            }

            if (debugModalEnabled) {
                svcResponse.debug.showModal = true;
            }

            this.createPanelComponent(viewContainerRef, svcResponse);
        } catch (e) {
            this.logger.warn('Unable to create debug panel!');
        }
    }

    private createPanelComponent(viewContainerRef: ViewContainerRef, svcResponse: any) {
        from(this.lazyLoader.lazyLoadComponent('debug-panel', viewContainerRef, svcResponse))
            .pipe(first())
            .subscribe(() => {
                // Create the component
                const componentRef = viewContainerRef.createComponent(DebugPanelComponent);
                // Assign the data to the component
                componentRef.instance.svcResponse = svcResponse;
            });
    }
}
